<template>
  <div>
    <div style="display: none">{{ triggerDialogEditGroup }}</div>
    <el-dialog
      class="popup NC-setting NC-setting_M"
      :class="SelectPopupClass()"
      :visible.sync="addGroupDialog"
      :before-close="handleClose"
      top="0"
      @opened="handleOpened()"
    >
      <div>
        <div class="popupContainer">
          <div class="p-head">
            {{ dialogMode == "create" ? "新增群組" : "修改群組" }}
          </div>
          <div class="p-body">
            <div class="groupSetting">
              <input
                type="text"
                v-model="groupName"
                placeholder="群組名稱"
                maxlength="15"
              />
              <input
                class="searchFriend"
                v-model="SearchText"
                type="text"
                placeholder="搜尋好友"
              />
            </div>
            <div class="chooseFriends">
              <div class="f-List foo5">
                <ul>
                  <li
                    v-for="(detail, index) in friendList.filter((data) =>
                      this.searchFilter(data)
                    )"
                  >
                    <label :for="detail.socialLeadId" style="width: 100%">
                      <img
                        v-bind:src="detail.imgUrl"
                        onerror="onerror=null;src='../static/img/avatar-default.jpg'"
                      />
                      <div class="listDesc">
                        <h3>{{ detail.name }} / {{ detail.leadName }}</h3>
                      </div>
                      <div class="listRight">
                        <input
                          type="checkbox"
                          :id="detail.socialLeadId"
                          v-model="ispicked"
                          :value="detail.socialLeadId"
                        />
                      </div>
                    </label>
                  </li>
                </ul>
              </div>
            </div>
            <FriendGroup_ChoisePhoto
              ref="ChoisePhoto"
            ></FriendGroup_ChoisePhoto>
          </div>
          <div class="p-foot" v-if="dialogMode == 'create'">
            <a @click="save" style="color: #fff">儲存</a>
          </div>
          <div class="p-foot editgroup" v-if="dialogMode == 'edit'">
            <a @click="save" style="color: #fff">儲存</a>
            <a @click="deletegroup" style="color: #fff">刪除</a>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import FriendGroup_ChoisePhoto from "../Main/FriendGroup_ChoisePhoto.vue";
import { FriendGroupHandler } from "../../handler/FriendGroup.js";
import { FriendListHandler } from "../../handler/FriendListHandler.js";
import store_groupList from "../../vuex/store_groupList.js";
import { TutorChatTokenHandler } from "@/handler/TutorChatTokenHandler.js";
import { isMobile } from "mobile-device-detect";
export default {
  data() {
    return {
      addGroupDialog: false,
      ispicked: [],
      friendList: [],
      dialogMode: "create",
      groupName: "",
      SearchText: "",
      mode: {
        type: "PC",
        token: "",
        staff: [],
      },
    };
  },
  components: {
    FriendGroup_ChoisePhoto,
  },
  created() {
    this.mode.staff = this.GetLoginStaff();
    var ticket = this.GetTicket();
    this.mode.token = TutorChatTokenHandler.getTctToken(ticket);
  },
  methods: {
    save: function () {
      if (this.groupName == "") {
        alert("群組名稱空白");
        return;
      }
      if (this.$refs.ChoisePhoto.selecttor == "") {
        alert("尚未選擇好友群組頭像");
        return;
      }

      //新增群組
      FriendGroupHandler.AddGroup(
        this.mode.staff.staffid,
        this.groupName,
        this.ispicked,
        this.groupId,
        this.$refs.ChoisePhoto.selecttor
      );

      //重新載入資料
      FriendGroupHandler.GetGroup(this.mode.staff.staffid);

      if (this.groupId != "") {
        //取得群組好友
        FriendListHandler.GetGroupFriendList(
          this.groupId,
          this.mode.staff.staffid
        );
      }

      this.addGroupDialog = false;
    },
    deletegroup: function () {
      if (!confirm("確定刪除")) {
        return;
      }
      FriendGroupHandler.DeleteGroup(this.mode.staff.staffid, this.groupId);
      //重新載入資料
      FriendGroupHandler.GetGroup(this.mode.staff.staffid);

      if (this.groupId != "") {
        //取得群組好友
        FriendListHandler.GetGroupFriendList(
          this.groupId,
          this.mode.staff.staffid
        );
      }
      this.addGroupDialog = false;
    },
    showAdd: function () {
      this.addGroupDialog = true;
      this.groupName = "";
      this.groupId = "";
      this.ispicked = [];
      this.SearchText = "";
      this.friendList = FriendGroupHandler.GetAllFriend(this.mode.token);
      this.dialogMode = "create";
      this.friendGroupPhotoURL = "";
    },
    showedit: function (group) {
      this.addGroupDialog = true;
      this.groupName = group.GroupName;
      this.groupId = group.Id;
      this.SearchText = "";
      this.dialogMode = "edit";

      this.friendList = FriendGroupHandler.GetAllFriend(this.mode.token);
      var friendItem = FriendListHandler.GetGroupFriendItem(
        group.Id,
        this.mode.staff.staffid
      );

      //2020/08/26 如果直接PUSH this.ispicked 會造成computed監控這個參數，只要一打勾或取消打勾就會觸發，導致沒辦法修改群組成員。
      var temp = [];
      friendItem.forEach((item) => {
        temp.push(item.socialLeadId);
      });
      this.ispicked = temp;

      this.friendGroupPhotoURL = group.FriendGroupPhotoURL;
    },
    handleOpened() {
      this.$refs.ChoisePhoto.selecttor = this.friendGroupPhotoURL;
    },
    handleClose(done) {
      done();
    },
    searchFilter: function (data) {
      var match =
        !this.SearchText ||
        data.name.toLowerCase().indexOf(this.SearchText.toLowerCase()) >= 0 ||
        data.leadName.toLowerCase().indexOf(this.SearchText.toLowerCase()) >=
          0 ||
        data.tagName.toLowerCase().indexOf(this.SearchText.toLowerCase()) >=
          0 ||
        data.ListClass.toLowerCase().indexOf(this.SearchText.toLowerCase()) >=
          0;
      return match;
    },
    SelectPopupClass() {
      if (isMobile) {
        return "NC-setting_MB";
      }
    },
  },
  computed: {
    triggerDialogEditGroup() {
      var flag = store_groupList.state.flag;
      if (flag > 0 && !store_groupList.state.group) {
        this.showAdd();
      }
      if (flag > 0 && store_groupList.state.group) {
        this.showedit(store_groupList.state.group);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Main/Dialog_EditGroup.vue